import React from 'react';
import { DialogContent, Box, CircularProgress } from '@mui/material';
import DialogModal from '../../../components/DialogModal';

interface ViewDeclarationFileDialogProps {
  open: boolean;
  onClose: () => void;
  fileUrl: string | null;
  isLoading: boolean;
  title: string;
}

const ViewDeclarationFileDialog: React.FC<ViewDeclarationFileDialogProps> = ({
  open,
  onClose,
  fileUrl,
  isLoading,
  title
}) => {
  return (
    <DialogModal
      open={open}
      onClose={onClose}
      title={title}
      maxWidth='md'
      PaperPropsSx={{ height: '80vh' }}
    >
      <DialogContent
        sx={{
          p: 0,
          height: '100%',
          width: '100%',
          overflow: 'hidden'
        }}
      >
        {isLoading ? (
          <Box
            display='flex'
            justifyContent='center'
            alignItems='center'
            height='100%'
          >
            <CircularProgress />
          </Box>
        ) : fileUrl ? (
          <Box
            width='100%'
            height='100%'
            style={{ border: 'none' }}
            sx={{ overflowX: 'auto' }}
            dangerouslySetInnerHTML={{ __html: fileUrl }}
          />
        ) : (
          <Box
            display='flex'
            justifyContent='center'
            alignItems='center'
            height='100%'
          >
            No file available to view.
          </Box>
        )}
      </DialogContent>
    </DialogModal>
  );
};

export default ViewDeclarationFileDialog;
